// migrated 1:1 from @nexato/nx-core-module, #688
import { Component, forwardRef, Injector, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl, Validators } from '@angular/forms';

@Component({
    selector: 'nx-edit-number-input',
    template: `
    <div>
      <label for="number">{{label | translate}}<ng-container *ngIf="suffix"> ({{suffix | translate}})</ng-container><ng-container *ngIf=isRequired()>*</ng-container></label>
      <input
        [type]="'number'"
        [value]="number"
        (input)="onInputChange($event)"
        (blur)="onBlur()"
        [placeholder]=placeholder
        id="number"
        pInputText
        [disabled]="isDisabled"
        [ngClass]="{'invalid': ngControl?.invalid && ngControl?.touched}"
      />
      <small *ngIf="helpText">{{helpText | translate}}</small>
    </div>
  `,
    styles: [`

  `],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EditNumberInputComponent),
            multi: true
        }
    ]
})
export class EditNumberInputComponent implements ControlValueAccessor, OnInit {

    ngControl: NgControl;
    isDisabled: boolean;
    @Input() label: string;
    @Input() placeholder: string = '';
    @Input() helpText: string;
    @Input() maskContent: boolean = false;
    @Input() suffix: string;

    number: number;

    private onChange: (value: number) => void;
    private onTouched: () => void;

    constructor(private _injector: Injector) {
    }

    ngOnInit() {
        this.ngControl = this._injector.get(NgControl);
        this.ngControl.valueAccessor = this;
    }

    writeValue(number: number): void {
        this.number = number;
    }

    registerOnChange(fn: (value: number) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        // Optional: Implementieren Sie die Logik zum Deaktivieren des Steuerelements
        this.isDisabled = isDisabled;
    }

    onInputChange(event: Event): void {
        const input = event.target as HTMLInputElement;
        this.number = input.value as unknown as number;
        if (this.onChange) {
            this.onChange(this.number);
        }
    }

    onBlur(): void {
        if (this.onTouched) {
            this.onTouched();
        }
    }

    isRequired(): boolean {
        return this.ngControl?.control?.hasValidator(Validators.required);
    }

}
